import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import ContentTagForm from './ContentTagForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditContentTagScreen() {
  const { id } = useParams();

  if (!id) return;

  const tag = Api.Tag.useReadItem(id);

  if (!tag.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <Stack gap={1}>
          <HeaderBreadcrumbs
            title="Edit Content Tag"
            items={[
              { name: 'Library Content', url: '/library' },
              { name: 'Content Tags', url: '/library/content-tags' },
            ]}
          />
        </Stack>

        <ContentTagForm existing={tag.data} />
      </Stack>
    </ScreenWrap>
  );
}
